export enum CodeInputState {
  Phone = 'phone',
  Email = 'email',
}
